<template>
  <el-menu-item style="position: relative; padding-left: 0px; display: flex; align-items: center" @click="$emit('click', state)">
    <i :class="icon"></i> {{ title }}
    <el-avatar class="messages-number" size="small" shape="square">{{
      total
    }} </el-avatar>
  </el-menu-item>
</template>

<script>
export default {
  props: {
    state: Number,
    icon: String,
    title: String,
    total: Number,
  },
}
</script>